import { IClassName } from '~@Types/components/IClassName'

export default function VisionarySymbol({ className }: IClassName) {
  return (
    <svg
      className={className}
      width="216"
      height="216"
      viewBox="0 0 216 216"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M86.4001 61.7144C86.4001 65.1228 83.6371 67.8858 80.2287 67.8858C76.8203 67.8858 74.0573 65.1228 74.0573 61.7144C74.0573 58.306 76.8203 55.543 80.2287 55.543C83.6371 55.543 86.4001 58.306 86.4001 61.7144ZM123.429 61.7144C123.429 65.1228 120.666 67.8858 117.257 67.8858C113.849 67.8858 111.086 65.1228 111.086 61.7144C111.086 58.306 113.849 55.543 117.257 55.543C120.666 55.543 123.429 58.306 123.429 61.7144ZM135.772 86.4001C139.18 86.4001 141.943 83.6371 141.943 80.2287C141.943 76.8203 139.18 74.0573 135.772 74.0573C132.363 74.0573 129.6 76.8203 129.6 80.2287C129.6 83.6371 132.363 86.4001 135.772 86.4001ZM160.457 61.7144C160.457 65.1228 157.694 67.8858 154.286 67.8858C150.877 67.8858 148.114 65.1228 148.114 61.7144C148.114 58.306 150.877 55.543 154.286 55.543C157.694 55.543 160.457 58.306 160.457 61.7144ZM154.286 104.914C157.694 104.914 160.457 102.151 160.457 98.743C160.457 95.3346 157.694 92.5715 154.286 92.5715C150.877 92.5715 148.114 95.3346 148.114 98.743C148.114 102.151 150.877 104.914 154.286 104.914ZM160.457 135.772C160.457 139.18 157.694 141.943 154.286 141.943C150.877 141.943 148.114 139.18 148.114 135.772C148.114 132.363 150.877 129.6 154.286 129.6C157.694 129.6 160.457 132.363 160.457 135.772ZM117.257 104.914C120.666 104.914 123.429 102.151 123.429 98.743C123.429 95.3346 120.666 92.5715 117.257 92.5715C113.849 92.5715 111.086 95.3346 111.086 98.743C111.086 102.151 113.849 104.914 117.257 104.914ZM104.914 117.257C104.914 120.666 102.151 123.429 98.743 123.429C95.3346 123.429 92.5715 120.666 92.5715 117.257C92.5715 113.849 95.3346 111.086 98.743 111.086C102.151 111.086 104.914 113.849 104.914 117.257ZM80.2287 141.943C83.6371 141.943 86.4001 139.18 86.4001 135.772C86.4001 132.363 83.6371 129.6 80.2287 129.6C76.8203 129.6 74.0573 132.363 74.0573 135.772C74.0573 139.18 76.8203 141.943 80.2287 141.943ZM67.8858 154.286C67.8858 157.694 65.1228 160.457 61.7144 160.457C58.306 160.457 55.543 157.694 55.543 154.286C55.543 150.877 58.306 148.114 61.7144 148.114C65.1228 148.114 67.8858 150.877 67.8858 154.286Z"
        fill="url(#paint0_linear_6851_1074)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6851_1074"
          x1="55.543"
          y1="108"
          x2="160.457"
          y2="108"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7D003D" />
          <stop offset="0.476296" stopColor="#E92184" />
          <stop offset="1" stopColor="#1F9E82" />
        </linearGradient>
      </defs>
    </svg>
  )
}
